import { isEqual } from 'lodash'

export const areOptionValuesEqual = <ValueType>(
  a: ValueType | undefined,
  b: ValueType | undefined,
) => {
  if (Object.is(a, b)) return true

  if (
    a === undefined ||
    b === undefined ||
    a === null ||
    b === null ||
    typeof a !== 'object' ||
    typeof b !== 'object'
  ) {
    return false
  }

  return isEqual(a, b)
}
